import { Market } from "@openbook-dex/openbook";
import { PublicKey, Transaction } from "@solana/web3.js";
import { sendWalletTransaction } from "./transaction";

export async function crank(connection, wallet, serumMarket: Market, eq) {
    try {
    const tx = new Transaction();
    for (let i = 0; i < Math.min(20, eq.length); i++)
        tx.add(serumMarket.makeConsumeEventsInstruction([eq[i].openOrders], 65535))
    const txSig = await sendWalletTransaction(connection, tx, wallet);
    return txSig;
    } catch (e) {
        console.log(e);
    }
}
